import { lazy } from 'react';
import { ListChecks, ListPlus } from 'lucide-react';
import type { List, ListItem } from '@app/shared';
import type { SearchResult, WebModule } from '../../app/types.ts';
import { familyRecords, scoreText } from '../../platform/search.ts';

export const listsModule: WebModule = {
  id: 'lists',
  label: 'Lists',
  icon: ListChecks,
  path: '/lists',
  nav: { group: 'main', order: 20, bottomTab: true },
  routes: [
    { path: 'lists', lazy: async () => ({ Component: (await import('./ListsScreen.tsx')).ListsScreen }) },
    { path: 'lists/:listId', lazy: async () => ({ Component: (await import('./ListDetail.tsx')).ListDetail }) },
  ],
  home: [{ id: 'shopping', title: 'Shopping list', order: 40, component: lazy(() => import('./home.tsx').then((m) => ({ default: m.ShoppingSection }))) }],
  quickActions: [{ id: 'list', label: 'List', icon: ListPlus, to: '/lists?add=1' }],
  async search(q, ctx) {
    const lists = await familyRecords<List>('lists', ctx.familyId);
    const items = await familyRecords<ListItem>('list_items', ctx.familyId);
    const nameOf = new Map(lists.map((l) => [l.id, l.name]));
    const out: SearchResult[] = [];
    for (const l of lists) {
      const score = scoreText(q, [l.name]);
      if (score) out.push({ key: `lists:${l.id}`, title: l.name, subtitle: 'List', to: `/lists/${l.id}`, group: 'Lists', icon: ListChecks, score });
    }
    for (const i of items) {
      const score = scoreText(q, [i.text, i.note, i.category]);
      if (score && nameOf.has(i.listId)) {
        out.push({
          key: `list_items:${i.id}`,
          title: i.text,
          subtitle: `${i.checked ? 'Checked · ' : ''}${nameOf.get(i.listId)}`,
          to: `/lists/${i.listId}`,
          group: 'Lists',
          icon: ListChecks,
          score: score - (i.checked ? 1 : 0),
        });
      }
    }
    return out;
  },
};
